import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Text,
  Input,
  Select,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  Table,
  TableContainer,
  VisuallyHidden,
  Tooltip,
  Radio,
  FormControl,
  FormLabel,
  Stack,
  RadioGroup,
} from "@chakra-ui/react";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectSearch from "react-select-search";
import { getAllHeaps, getCompanyData, getFarmers } from "../../api";
import isAllowed from "../../routing/isAllowed";
import { addProcurementForm, getClassification } from "../../api";
import "react-select-search/style.css";
import { getAllPrograms } from "../../redux/program/ProgramSlice";
import { getCompanyDetails } from "../../redux/company/CompanySlice";
import { useNavigate } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";
import { FileIcon, Loader, RemoveIcon } from "../../assets/svgs/Icons";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { DocumentViewer } from "../common/DocumentViewer";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import * as Yup from "yup";
import { checkFileTypesAndSize } from "../../Common/utils";
import { INVENTORY_TYPE } from "../../Common/Constants";

function ProcurementForm() {
  const [farmerDetails, setFarmerDetails] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [farmerId, setFarmerId] = useState("");
  const [isLoading, setIsloading] = useState();
  const [itemLoading, setItemloading] = useState();
  const dispatch = useDispatch();
  const [procurementFiles, setProcurementFiles] = useState(null);
  const [procurements, setProcurements] = useState([]);
  const [companyUnits, setCompanyUnits] = useState([]);
  const [companyProducts, setCompanyProducts] = useState([]);
  const [classification, setClassification] = useState([]);
  const [allClassifications, setAllClassifications] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorsCustom, setErrorsCustom] = useState({
    type: false,
    program: false,
    classification: false,
    netWeight: false,
    grossWeight: false,
    procureUnit: false,
    date: false,
  });
  const [allHeaps, setAllHeaps] = useState([]);
  const { userData } = useSelector((state) => state.auth);
  const { companyDetails } = useSelector((state) => state.company);

  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  const handleFetchHeaps = async () => {
    const response = await getAllHeaps();
    setAllHeaps(response?.data);
  };
  const getFarmer = async (farmerID) => {
    const token = localStorage.getItem("cu_user");
    if (!farmerID) {
      toast.error("Please select the farmer first");
      return;
    }
    try {
      if (!farmerID) return toast.error("Please select a farmer");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/farmer/${farmerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data) {
        toast.success("Farmer selected successfully");
      }
      setFarmerDetails(data.data);
    } catch (error) {
      window.alert("There was problem while fetching data", error.message);
    }
  };

  const getFarmersData = async () => {
    let farmers = await getFarmers();

    let farmerOPtions = farmers?.data.map((farmer) => {
      return {
        name: `${farmer?.firstName} ${farmer?.lastName}`,
        value: farmer?._id,
      };
    });
    setFarmers(farmerOPtions);
  };

  const getCompany = () => {
    try {
      const result = dispatch(getCompanyDetails(userData?.companyId));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getProgram = async () => {
    try {
      const result = await dispatch(getAllPrograms());
    } catch (error) {
      console.error(error.message);
    }
  };

  const getUnit = async () => {
    try {
      const result = await getCompanyData(userData?.companyId);

      setCompanyUnits(result?.data?.company_units);
      const filteredProduct = result?.data?.company_products.filter(
        (product) =>
          product.product_productClassification.name ===
          "Seed Cotton (raw cotton)"
      );
      setCompanyProducts(filteredProduct);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getProductClassification = async () => {
    try {
      const result = await getClassification();
      setAllClassifications(result?.data);
      const filteredProduct = result?.data?.filter(
        (product) => product.name === "Seed cotton (raw cotton)"
      );
      setClassification(filteredProduct);
    } catch (error) {
      console.error(error.message);
    }
  };

  const token = localStorage.getItem("cu_user");

  const handleProcurementFileChange = (event) => {
    const file = event.target.files[0];

    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );

    if (!validation.isValid) {
      setErrorMessage(validation.error);
      toast.error(validation.error);
      return;
    }

    setProcurementFiles(file);
    setErrorMessage("");

    toast.success("File Uploaded Successfully");
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const today = new Date();
  const dateValue = today.toISOString().substring(0, 10);
  const addToItems = async (values, resetForm) => {
    setItemloading(true);
    if (
      !values.type ||
      !values.programId ||
      !values.productClassification ||
      !values.grossWeight ||
      !values.netWeight ||
      !values.unitId ||
      !values.date ||
      !values.purchaseSlipNumber ||
      !values.heapId
    ) {
      setErrorsCustom({
        type: !values.type ? true : false,
        program: !values.programId ? true : false,
        classification: !values.productClassification ? true : false,
        netWeight: !values.netWeight ? true : false,
        grossWeight: !values.grossWeight ? true : false,
        procureUnit: !values.unitId ? true : false,
        purchaseSlipNumber: !values.purchaseSlipNumber ? true : false,
        date: !values.date ? true : false,
        heapId: !values.heapId ? true : false,
      });
      setItemloading(false);
      return toast.error("Please fill all the required fields");
    }
    let procurementFilesRequest;

    if (!procurementFiles) {
      return toast.info("Upload supporting documents");
    }

    try {
      if (procurementFiles) {
        const procurementFilesData = new FormData();

        procurementFilesData.append("document", procurementFiles);
        procurementFilesData.append("doc_type", "OTHER");
        procurementFilesData.append("userType", "CLIENT");
        procurementFilesData.append("documentInfo", "OTHER");

        procurementFilesRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: procurementFilesData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      let procurementValues = {
        procureId: uuidv4(),
        type: values.type,
        programId: values.programId,
        productClassification: values.productClassification,
        stockQuantity: {
          netWeight: values.netWeight,
          grossWeight: values.grossWeight,
        },
        unitId: values.unitId,
        date: values.date,
        procurementDocument: procurementFilesRequest?.data?.data?._id,
        procurementDocumentName: procurementFilesRequest?.data?.data?.name,
        transportDetails: values.vehicleNumber,
        purchaseSlipNumber: values.purchaseSlipNumber,
        heapId: values.heapId,
      };
      setProcurements((procurements) => [procurementValues, ...procurements]);

      toast.success("Procurement item added successfully");
      setItemloading(false);
      setProcurementFiles(null);

      resetForm();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
    setItemloading(false);
  };

  const removeProcure = (id) => {
    setProcurements((prev) =>
      prev.filter((procurement) => procurement.procureId !== id)
    );
    toast.success("Procurement removed successfully");
  };

  const getProgramName = (programId) => {
    return companyDetails?.data?.company_programs?.filter(
      (program) => program?._id === programId
    )?.[0]?.name;
  };

  const getUnitName = (unitId) => {
    return companyUnits?.filter((unit) => unit?._id === unitId)?.[0]?.name;
  };

  const getProductClassificationName = (productClassificationId) => {
    return allClassifications?.filter(
      (productClassification) =>
        productClassification?._id === productClassificationId
    )?.[0]?.name;
  };

  useEffect(() => {
    if (userData?.companyId) {
      getCompany();
    }
  }, [userData]);

  useEffect(() => {
    getFarmersData();
    getProgram();
    getUnit();
    getProductClassification();
    handleFetchHeaps();
  }, []);

  useEffect(() => {
    getCompany();
  }, []);

  return (
    <Box marginBottom={"3rem"}>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Grid templateColumns="repeat(3, 1fr)" marginTop={"5rem"}>
        <GridItem>
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Add Procurement Details
          </Text>
          <Text color={" #3958DC"} fontSize="sm">
            Please fill necessary details
          </Text>
        </GridItem>

        <GridItem></GridItem>
      </Grid>
      <Box
        marginTop={"3.3rem"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
      >
        Farmer's Details
      </Box>
      <Formik
        initialValues={{
          farmerId: "",
          type: "",
          programId: "",
          productClassification: "",
          netWeight: "",
          grossWeight: "",
          unitId: "",
          vehicleNumber: "",
          purchaseSlipNumber: "",
          date: "",
          payslipDocument: null,
          heapType: "",
          heapId: "",
        }}
        onSubmit={async (values, { resetForm }) => {
          if (!farmerId) {
            return toast.error("Please Select farmer before submitting.");
          }

          if (procurements.length <= 0) {
            return toast.info(
              "Please add at least one procurement item before submitting."
            );
          }

          setIsloading(true);

          let finalObj = {
            supplier: {
              id: farmerId,
              farmer: true,
            },
            procurements: procurements,
          };

          let response = await addProcurementForm(finalObj, setIsloading);
          if (response) {
            setFarmerDetails([]);
            navigate("/procurement");
            setIsloading(false);
          }
        }}
        validationSchema={Yup.object().shape({})}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            resetForm,
          } = props;

          return (
            <>
              <Box
                bg="white"
                p={"1rem"}
                mt="2rem"
                borderRadius="15px"
                boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                mb="2rem"
              >
                <Box mt="10" px="1rem">
                  <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        <Box
                          as="span"
                          borderRight={"3px solid #2272D5"}
                          height="40px"
                          marginRight={"1rem"}
                        ></Box>
                        Search and Select Farmer
                      </Text>
                      <Box display={"flex"} mt={"1rem"}>
                        <SelectSearch
                          options={farmers}
                          value={farmers?._id}
                          search
                          onChange={(e) => setFarmerId(e)}
                          placeholder="Search farmer"
                        />
                        <Button
                          bg={"#52BBFF"}
                          color={"#fff"}
                          w="130px"
                          _hover={{
                            bg: "#52BBFF",
                          }}
                          ml={"10"}
                          onClick={() => {
                            getFarmer(farmerId);
                          }}
                        >
                          Select
                        </Button>
                      </Box>
                    </GridItem>
                  </Grid>
                </Box>

                <Box mt="10" px="1rem">
                  <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        First Name
                      </Text>

                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="60%"
                        value={farmerDetails?.firstName}
                        border="2px solid  #8fd0fd !important"
                        disabled
                        opacity={"1 !important"}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Last Name
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="60%"
                        value={farmerDetails?.lastName}
                        border="2px solid  #8fd0fd !important"
                        opacity={"1 !important"}
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                  </Grid>
                </Box>
                <Box mt="10" px="1rem">
                  <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Email
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        opacity={"1 !important"}
                        border="2px solid  #8fd0fd !important"
                        bg={"#fff"}
                        w="60%"
                        placeholder=""
                        disabled
                        value={farmerDetails?.contactInfo?.email}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Farmer ID
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="60%"
                        value={farmerDetails?.id}
                        border="2px solid  #8fd0fd !important"
                        opacity={"1 !important"}
                        placeholder=""
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                  </Grid>
                </Box>
                <Box mt="10" px="1rem">
                  <Grid marginTop={"1rem"}>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Aadhar Number / Any ID Proof
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="53%"
                        value={farmerDetails?.idProof}
                        border="2px solid  #8fd0fd !important"
                        placeholder=""
                        opacity={"1 !important"}
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                  </Grid>
                </Box>
                <Box mt="10" px="1rem">
                  <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Contact Number
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="60%"
                        value={farmerDetails?.contactInfo?.phone}
                        border="2px solid  #8fd0fd !important"
                        placeholder=""
                        opacity={"1 !important"}
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Pincode
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="60%"
                        value={farmerDetails?.address?.pinCode}
                        border="2px solid  #8fd0fd !important"
                        opacity={"1 !important"}
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                  </Grid>
                </Box>
                <Box mt="10" px="1rem">
                  <Grid marginTop={"1rem"}>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Address
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="53%"
                        value={farmerDetails?.address?.raw_address}
                        border="2px solid  #8fd0fd !important"
                        opacity={"1 !important"}
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                  </Grid>
                </Box>
                <Box mt="10" px="1rem">
                  <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        City
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="60%"
                        value={farmerDetails?.address?.city}
                        border="2px solid  #8fd0fd !important"
                        opacity={"1 !important"}
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        State
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        bg={"#fff"}
                        w="60%"
                        value={farmerDetails?.address?.state}
                        border="2px solid  #8fd0fd !important"
                        opacity={"1 !important"}
                        disabled
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                  </Grid>
                </Box>
                <Box
                  marginTop={"1rem"}
                  color={"#000000"}
                  // padding={"10px 2rem"}
                  fontWeight="900"
                  marginLeft="-2.3rem"
                  marginRight={"-2.5rem"}
                  px="3rem"
                  py="1rem"
                >
                  Farm Details
                </Box>
                {farmerDetails?.farmer_farm_details?.length > 0 ? (
                  <Grid templateColumns="repeat(4, 1fr)" px="3rem" py="1rem">
                    <GridItem colSpan={1} ml="2">
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Land Size (Acres)
                      </Text>
                    </GridItem>
                    <GridItem ml="2" colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Cultivation Capacity (kg)
                      </Text>
                    </GridItem>
                    <GridItem ml="2" colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Longitude
                      </Text>
                    </GridItem>
                    <GridItem ml="2" colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Latitude
                      </Text>
                    </GridItem>
                  </Grid>
                ) : (
                  "N/A"
                )}
                {farmerDetails?.farmer_farm_details?.map((el) => {
                  return (
                    <Box mt="5" px="3rem" py="1rem">
                      <Grid
                        templateColumns="repeat(4, 1fr)"
                        marginTop={"-3rem"}
                      >
                        <GridItem colSpan={1}>
                          <Input
                            type="text"
                            color={"#141D43"}
                            marginTop="10px"
                            bg={"#fff"}
                            w="60%"
                            value={el?.landSize ? el?.landSize : "N/A"}
                            placeholder="Land Size"
                            disabled
                            opacity={"1 !important"}
                            fontSize={"14px"}
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                        </GridItem>
                        <GridItem>
                          <Input
                            type="text"
                            color={"#141D43"}
                            marginTop="10px"
                            bg={"#fff"}
                            w="60%"
                            value={
                              el?.cultivationCapacity
                                ? el?.cultivationCapacity
                                : "N/A"
                            }
                            disabled
                            opacity={"1 !important"}
                            fontSize={"14px"}
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                        </GridItem>

                        <GridItem>
                          <Input
                            type="text"
                            color={"#141D43"}
                            marginTop="10px"
                            bg={"#fff"}
                            w="60%"
                            value={
                              el?.address?.location?.coordinates[0]
                                ? el?.address?.location?.coordinates[0]
                                : "N/A"
                            }
                            disabled
                            opacity={"1 !important"}
                            fontSize={"14px"}
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                        </GridItem>

                        <GridItem>
                          <Input
                            type="text"
                            color={"#141D43"}
                            marginTop="10px"
                            bg={"#fff"}
                            w="60%"
                            value={
                              el?.address?.location?.coordinates[1]
                                ? el?.address?.location?.coordinates[1]
                                : "N/A"
                            }
                            disabled
                            opacity={"1 !important"}
                            fontSize={"14px"}
                            _placeholder={{
                              opacity: 1,
                              color: " #464C64",
                              fontSize: "14px",
                            }}
                          />
                        </GridItem>
                      </Grid>
                    </Box>
                  );
                })}
              </Box>
              <Box
                marginTop={"1.5rem"}
                color={"#fff"}
                padding={"10px 2rem"}
                fontWeight="700"
                marginLeft="-1.7rem"
                marginRight={"-2.5rem"}
                bg={
                  "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
                }
                borderTopRightRadius="100px"
                borderBottomRightRadius={"80px 80px"}
              >
                Procurement Details
              </Box>
              <Box>
                <Grid mt="5"></Grid>
              </Box>
              <Box
                bg="white"
                p={"1rem"}
                mt="1rem"
                borderRadius="15px"
                boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
              >
                <Box px="1rem">
                  <Box mt="10">
                    <Grid templateColumns="repeat(3, 1fr)">
                      <GridItem colSpan={1} w="175px">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Product Type&nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          id="type"
                          marginTop="10px"
                          bgColor="white"
                          color="#464C64"
                          border="2px solid #8fd0fd !important"
                          fontSize="sm"
                          value={values.type}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              type: false,
                            }));
                          }}
                          _focusVisible={
                            errorsCustom.type
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          onBlur={handleBlur}
                        >
                          <option hidden="true">Select Type</option>
                          {Object.keys(INVENTORY_TYPE).map((key) => (
                            <option key={key} value={INVENTORY_TYPE[key]}>
                              {INVENTORY_TYPE[key]}
                            </option>
                          ))}
                        </Select>
                        {errorsCustom.type && (
                          <Box color="red.500">Type is required</Box>
                        )}
                      </GridItem>
                      <GridItem mt="1rem">
                        <FormControl>
                          <FormLabel
                            color="#141D43"
                            fontSize="md"
                            fontWeight="700"
                          >
                            Heap No.&nbsp;
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <RadioGroup
                            onChange={(value) =>
                              setFieldValue("heapType", value)
                            }
                            value={values.heapType}
                          >
                            <Stack direction="row">
                              <Radio value="new">New Heap</Radio>
                              <Radio value="previous">
                                Select Previous Heap
                              </Radio>
                            </Stack>
                          </RadioGroup>
                          {values.heapType === "new" ? (
                            <Input
                              id="heapId"
                              placeholder="Heap No."
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              mt="10px"
                              color="#141D43"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isProductSectionVisible", true);
                                setErrorsCustom((prev) => ({
                                  ...prev,
                                  heapId: false,
                                }));
                              }}
                              onBlur={handleBlur}
                              value={values.heapId}
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                          ) : values.heapType === "previous" ? (
                            <Select
                              id="heapId"
                              placeholder="Select previous heap"
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              mt="10px"
                              color="#141D43"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isProductSectionVisible", true);
                                setErrorsCustom((prev) => ({
                                  ...prev,
                                  heapId: false,
                                }));
                              }}
                              onBlur={handleBlur}
                              value={values.heapId}
                            >
                              {allHeaps?.map((data, index) => (
                                <option value={data?.number} key={index}>
                                  {data?.number}
                                </option>
                              ))}
                            </Select>
                          ) : null}
                        </FormControl>
                        {errorsCustom.heapId && (
                          <Box color="red.500">Heap is required</Box>
                        )}
                      </GridItem>
                    </Grid>
                    <Grid templateColumns="repeat(3, 1fr)" mt="10px">
                      <GridItem colSpan={1} w="175px">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Program &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          mt="1rem"
                          bgColor="white"
                          id="programId"
                          color={" #464C64"}
                          fontSize="sm"
                          border="2px solid  #8fd0fd !important"
                          value={values.programId}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              program: false,
                            }));
                          }}
                          _focusVisible={
                            errorsCustom.program
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          onBlur={handleBlur}
                        >
                          <option hidden="true">Select a Program</option>
                          {companyDetails?.data?.company_programs?.map(
                            (program) => (
                              <option key={program?._id} value={program?._id}>
                                {program.name}
                              </option>
                            )
                          )}
                        </Select>
                        {errorsCustom.program && (
                          <Box color="red.500">Program is required</Box>
                        )}
                      </GridItem>
                      <GridItem colSpan={1} w="175px">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Classification &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                          <Select
                            mt="1rem"
                            bgColor="white"
                            color={" #464C64"}
                            border="2px solid  #8fd0fd !important"
                            id="productClassification"
                            fontSize="sm"
                            _focusVisible={
                              errorsCustom.classification
                                ? {
                                    border: "1px solid red !important",
                                  }
                                : { border: "1px solid #464C64" }
                            }
                            value={values.productClassification}
                            onChange={(e) => {
                              handleChange(e);
                              setErrorsCustom((prev) => ({
                                ...prev,
                                classification: false,
                              }));
                            }}
                            onBlur={handleBlur}
                          >
                            <option hidden="true">
                              Select Product Classification
                            </option>
                            <option
                              default="true"
                              value={classification?.[0]?._id}
                            >
                              {classification?.[0]?.name}
                            </option>
                          </Select>
                          {errorsCustom.classification && (
                            <Box color="red.500">
                              Product classification is required
                            </Box>
                          )}
                        </Text>
                      </GridItem>
                      <GridItem colSpan={1} w="175px">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Net Weight (Kg) &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          mt="1rem"
                          bgColor="white"
                          type="number"
                          id="netWeight"
                          _focusVisible={
                            errorsCustom.netWeight
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          border="2px solid  #8fd0fd !important"
                          value={values.netWeight}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              netWeight: false,
                            }));
                          }}
                          onBlur={handleBlur}
                        />
                        {errorsCustom.netWeight && (
                          <Box color="red.500">Net weight is required</Box>
                        )}
                      </GridItem>
                      <GridItem colSpan={1} w="175px" mt="1rem">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Gross Weight (Kg) &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          mt="1rem"
                          bgColor="white"
                          type="number"
                          id="grossWeight"
                          _focusVisible={
                            errorsCustom.grossWeight
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          border="2px solid  #8fd0fd !important"
                          value={values.grossWeight}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              grossWeight: false,
                            }));
                          }}
                          onBlur={handleBlur}
                        />
                        {errorsCustom.grossWeight && (
                          <Box color="red.500">Gross Weight is Required</Box>
                        )}
                      </GridItem>

                      <GridItem colSpan={1} w="175px" mt="1rem">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Procurement Unit &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          mt="1rem"
                          bgColor="white"
                          color={" #464C64"}
                          border="2px solid  #8fd0fd !important"
                          id="unitId"
                          fontSize="sm"
                          _focusVisible={
                            errorsCustom.procureUnit
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          value={values.unitId}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              procureUnit: false,
                            }));
                          }}
                          onBlur={handleBlur}
                        >
                          <option hidden="true">Select Unit</option>
                          {companyUnits?.map((data, index) => (
                            <option
                              default="true"
                              value={data?._id}
                              key={index}
                            >
                              {data?.name}
                            </option>
                          ))}
                        </Select>
                        {errorsCustom.procureUnit && (
                          <Box color="red.500">
                            Procurement unit is required
                          </Box>
                        )}
                      </GridItem>
                      <GridItem colSpan={1} w="175px" mt="1rem">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Transport Document
                        </Text>
                        <Input
                          mt="1rem"
                          bgColor="white"
                          id="vehicleNumber"
                          border="2px solid  #8fd0fd !important"
                          value={values.vehicleNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </GridItem>
                      <GridItem colSpan={1} w="205px" mt="1rem">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Purchase Slip Number &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          mt="1rem"
                          bgColor="white"
                          w="175px"
                          id="purchaseSlipNumber"
                          border="2px solid  #8fd0fd !important"
                          value={values.purchaseSlipNumber}
                          // onChange={handleChange}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              purchaseSlipNumber: false,
                            }));
                          }}
                          onBlur={handleBlur}
                        />
                      </GridItem>
                      <GridItem colSpan={1} w="175px" mt="1rem">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Date &nbsp;
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          mt="1rem"
                          type={"date"}
                          bgColor="white"
                          id="date"
                          defaultValue={dateValue}
                          border="2px solid  #8fd0fd !important"
                          value={values.date}
                          onChange={(e) => {
                            handleChange(e);
                            setErrorsCustom((prev) => ({
                              ...prev,
                              date: false,
                            }));
                          }}
                          _focusVisible={
                            errorsCustom.date
                              ? {
                                  border: "1px solid red !important",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          onBlur={handleBlur}
                        />
                        {errorsCustom.date && (
                          <Box color="red.500">Date is required</Box>
                        )}
                      </GridItem>
                      <GridItem colSpan={1} w="175px" mt="1rem">
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Document
                        </Text>
                        <Box mt="1rem">
                          {procurementFiles ? (
                            <Box
                              display={"flex"}
                              className="overflow-style"
                              boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px"
                            >
                              <>
                                <Box
                                  bg="#FFFFFF"
                                  w={"250px"}
                                  borderRadius={"15px"}
                                >
                                  <Box
                                    display={"flex"}
                                    justifyContent={"right"}
                                  >
                                    <Button
                                      borderColor="#FFFFFF"
                                      bg="#ffffff"
                                      size="sm"
                                      variant="outline"
                                      onClick={() => setProcurementFiles(null)}
                                      leftIcon={<RemoveIcon />}
                                    ></Button>
                                  </Box>
                                  <Box
                                    display={"flex"}
                                    justifyContent={"center"}
                                  >
                                    <FileIcon />
                                  </Box>
                                  <Tooltip label={procurementFiles?.name}>
                                    <Text
                                      margin={"auto"}
                                      width={"130px"}
                                      whiteSpace={"nowrap"}
                                      overflow={"hidden"}
                                      textOverflow={"ellipsis"}
                                    >
                                      {procurementFiles?.name}
                                    </Text>
                                  </Tooltip>
                                </Box>
                              </>
                            </Box>
                          ) : (
                            <Tooltip label="Please exercise caution when uploading a document, as once it has been uploaded, it cannot be removed or changed.">
                              <Button
                                color="blue.400"
                                bg={"#FFFFFF"}
                                leftIcon={<FiUpload />}
                                borderRadius={"15px"}
                                as="label"
                                htmlFor="file-upload"
                                variant="outline"
                              >
                                Upload
                                <VisuallyHidden>
                                  <input
                                    id="file-upload"
                                    type="file"
                                    onChange={handleProcurementFileChange}
                                  />
                                </VisuallyHidden>
                              </Button>
                            </Tooltip>
                          )}
                        </Box>
                      </GridItem>
                    </Grid>
                  </Box>
                  <Box mt="1rem" display={"flex"} justifyContent={"center"}>
                    {errorMessage && (
                      <Box
                        bg="crimson"
                        color="white"
                        p="1rem"
                        borderRadius="15px"
                        mb="1rem"
                        w="60%"
                        textAlign={"center"}
                      >
                        {errorMessage}
                        <Button
                          size="sm"
                          variant="outline"
                          ml="1rem"
                          bg="white"
                          color="black"
                          onClick={clearErrorMessage}
                        >
                          <RemoveIcon />
                        </Button>
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <GridItem mt={"1rem"}>
                      <Button
                        w="175px"
                        bg="#52BBFF"
                        disabled={itemLoading || procurementFiles === null}
                        color={"#fff"}
                        _hover={{ bg: "#52BBFF" }}
                        onClick={() =>
                          itemLoading ? "" : addToItems(values, resetForm)
                        }
                      >
                        {itemLoading ? (
                          <Loader width="25px" height="25px" />
                        ) : (
                          "Add item"
                        )}
                      </Button>
                    </GridItem>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Grid
                  templateColumns="repeat(1, 1fr)"
                  style={{ paddingLeft: "0 !important" }}
                  width={"100%"}
                >
                  <Text
                    color={"#141D43"}
                    fontSize="md"
                    fontWeight={"800"}
                    fontFamily={"font.roboto"}
                    margin={"1rem"}
                  >
                    Procurements
                    <Box
                      border={"2px solid #2272D5"}
                      width="10%"
                      marginBottom={"1rem"}
                    ></Box>
                  </Text>

                  <GridItem
                    width={"100%"}
                    overflowY={"scroll"}
                    className="overflow-style"
                  >
                    {procurements?.length > 0 ? (
                      <TableContainer className="overflow-style">
                        <Table
                          variant={"simple"}
                          size="md"
                          bg={"#fff"}
                          borderRadius={"15px"}
                          pr={"1rem"}
                        >
                          <Thead>
                            <Tr>
                              <Th color="brand.blue" textTransform="capitalize">
                                Sr no.
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Date
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Program
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Product Classification
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Net Weight (Kg)
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Gross Weight (Kg)
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Procurement Unit
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Transport Document
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Invoice Number
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Heap No.
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Document
                              </Th>
                              <Th color="brand.blue" textTransform="capitalize">
                                Action
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {procurements?.map((data, index) => {
                              return (
                                <Tr>
                                  <Td>{index + 1}</Td>
                                  <Td>{data?.date ? data?.date : "N/A"}</Td>
                                  <Td>
                                    {data?.programId
                                      ? getProgramName(data?.programId)
                                      : "N/A"}
                                  </Td>
                                  <Td>
                                    {data?.productClassification
                                      ? getProductClassificationName(
                                          data?.productClassification
                                        )
                                      : "N/A"}
                                  </Td>
                                  <Td>
                                    {data?.stockQuantity?.netWeight
                                      ? data?.stockQuantity?.netWeight
                                      : "N/A"}
                                  </Td>
                                  <Td>
                                    {data?.stockQuantity?.grossWeight
                                      ? data?.stockQuantity?.grossWeight
                                      : "N/A"}
                                  </Td>
                                  <Td>
                                    {" "}
                                    {data?.unitId
                                      ? getUnitName(data?.unitId)
                                      : "N/A"}
                                  </Td>
                                  <Td>{data?.transportDetails}</Td>
                                  <Td>{data?.purchaseSlipNumber}</Td>
                                  <Td>{data.heapId}</Td>
                                  <Td>
                                    <Tooltip
                                      label={data?.procurementDocumentName}
                                    >
                                      <Text
                                        maxWidth="50px"
                                        overflow="hidden"
                                        textOverflow="ellipsis"
                                      >
                                        {data?.procurementDocumentName}
                                      </Text>
                                    </Tooltip>
                                  </Td>

                                  <Td>
                                    <Box
                                      cursor="pointer"
                                      onClick={() =>
                                        removeProcure(data.procureId)
                                      }
                                    >
                                      <RemoveIcon />
                                    </Box>
                                  </Td>
                                </Tr>
                              );
                            })}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    ) : (
                      "Added Procurements will appear here"
                    )}
                  </GridItem>
                </Grid>
              </Box>
              <Box>
                <Grid mt="7">
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      marginBottom={"1rem"}
                      fontFamily={"font.roboto"}
                    >
                      Click the button below to submit procurements
                    </Text>
                    <Button
                      type="submit"
                      w="130px"
                      disabled={isLoading ? true : ""}
                      onClick={() => (isLoading ? "" : handleSubmit(values))}
                      bg="#52BBFF"
                      color={"#fff"}
                      _hover={{ bg: "#52BBFF" }}
                    >
                      {isLoading ? (
                        <Loader width="25px" height="25px" />
                      ) : (
                        "Submit Form"
                      )}
                    </Button>
                  </GridItem>
                </Grid>
              </Box>
            </>
          );
        }}
      </Formik>
    </Box>
  );
}

export default isAllowed(ProcurementForm);
